<script>
import moment from 'moment';

export default {
  name: 'DevPanel',
  data: () => ({
    eventsFromCEF: [
      // 'stationIdentityChanged',
      'audioChanged',
      // 'devicesChanged',
      'appChanged',
      'dashboardChanged',
      'idleChanged',
      'steamVRChanged',
    ],
    argumentsForCEF: {
      // stationIdentityChanged: ,
      audioChanged: [{ volume: 0 }, { volume: 0.5 }, { volume: 1 }],
      devicesChanged: [
        [
          // [
          {
            serialNumber: 'string',
            type: 'Controller',
            role: 'LeftHand',
            charging: true,
            battery: 0.5,
          },
          {
            serialNumber: 'string',
            type: 'Controller',
            role: 'RightHand',
            charging: true,
            battery: 0.5,
          },
          // ],
        ],
      ],
      appChanged: [
        [{
          runningId: 'f7819630-4eb9-11e8-be36-03ca771e05ad',
          runningType: 'game',
          type: 'game',
          game: {
            id: 'f7819630-4eb9-11e8-be36-03ca771e05ad',
            title: 'Game',
          },
          contentOwnership: null,
          preset: null,
        }],
        [{
          runningId: 'b4373780-2877-11e8-a79e-1dccfb01cc0a',
          runningType: 'launcher',
          type: 'launcher',
          game: {
            id: 'b4373780-2877-11e8-a79e-1dccfb01cc0a',
            title: 'Launcher',
          },
          contentOwnership: null,
          preset: null,
        }],
        [{
          runningId: null,
          runningType: 'unknown_game',
          type: 'unknown_game',
          game: null,
          contentOwnership: null,
          preset: null,
        }],
      ],
      dashboardChanged: [{ visible: true }, { visible: false }],
      idleChanged: [{ idle: true }, { idle: false }],
      // steamVRChanged: [],
    },
  }),
  methods: {
    changeOffline (value) {
      if (!value) {
        this.$store.dispatch('recoverFromSafetyMode');
        return;
      }
      this.updateStation({
        safetyMode: value,
      });
    },
    toggleErrorPanel () {
      !this.$store.state.launcher.errors.initApp
        ? this.$store.commit('setError', 'initApp')
        : this.$store.commit('resetError', 'initApp');
    },
    changeNetworkAvaibility (value) {
      this.$store.commit('setNetworkAvaibility', value);
    },
    callCEF (method, value) {
      window.interopToJS[method](JSON.stringify(value));
    },
    updateStation (payload) {
      this.$store.dispatch('updateStationWithOptimistic', {
        payload,
      });
    },
    toggleTimerInfinite () {
      this.updateStation({
        timerEnabled: !this.$store.getters.currentStation.timerEnabled,
      });
    },
    togglePause () {
      const currentBookingTime = this.$store.getters.currentBookingTime;
      if (!currentBookingTime) return;
      this.$store.commit('setBookingTimes', [{
        ...currentBookingTime,
        pausedAt: currentBookingTime.pausedAt ? null : moment().toISOString(),
        pausedDuration: currentBookingTime.pausedAt ? null : this.$store.getters.remainingTime / 1000,
      }]);
    },
    generateBooking (seconds) {
      const bookingStationTimes = [
        {
          id: 'mock',
          startedAt: moment.utc(this.$store.getters.currentTime).subtract(1, 's').toISOString(),
          endTime: moment.utc(this.$store.getters.currentTime).add(seconds, 's').toISOString(),
          pausedAt: null,
          station: {
            id: this.$store.getters.stationId,
          },
          booking: {
            id: '',
            host: {
              id: null,
            },
          },
        },
      ];
      this.$store.commit('setBookingTimes', bookingStationTimes);
    },
  },
};
</script>

<template lang="pug">
div.dev-panel.bg-white.pa2.overflow-y-scroll._collision.relative
  button.bg-black-overlay.white.b.f8.br1.pa2(type="button", @click="toggleTimerInfinite") toggle timer infinite
  button.bg-black-overlay.white.b.f8.br1.pa2(type="button", @click="generateBooking((5*60) + 20)") generate booking 5min
  button.bg-black-overlay.white.b.f8.br1.pa2(type="button", @click="generateBooking(10)") generate booking 10 sec
  button.bg-black-overlay.white.b.f8.br1.pa2(type="button", @click="togglePause") toggle pause on current booking
  button.bg-black-overlay.white.b.f8.br1.pa2(type="button", @click="toggleErrorPanel") toggle error panel
  ul
    li.tl.pa3.f7.fw6.b.mb2.w-100.bg-green.dark-gray
      h3 networkAvaibility (health-check)
      hr.mv1
      label.mr4
        input.mr2(type='radio', :value="true", name="networkAvaibility",:checked="$store.getters.isNetworkAvailable === true",  @change="changeNetworkAvaibility(true)")
        span service up
      label.mr4
        input.mr2(type='radio', :value="false", name="networkAvaibility", :checked="$store.getters.isNetworkAvailable === false", @change="changeNetworkAvaibility(false)")
        span service down
    li.tl.pa3.f7.fw6.b.mb2.w-100.bg-green.dark-gray
      h3 safetyMode
      hr.mv1
      label.mr4
        input.mr2(type='radio', :value="true", :checked="$store.getters.safetyMode === true", name="offline", @change="changeOffline(true)")
        span true
      label.mr4
        input.mr2(type='radio', :value="false", :checked="$store.getters.safetyMode === false", name="offline", @change="changeOffline(false)")
        span false
    li.tl.pa3.f7.fw6.b.mb2.w-100.bg-green.dark-gray(v-for="method in eventsFromCEF")
      h3 {{ method }}
      hr.mv1
      ul.flex(v-if="argumentsForCEF[method]")
        li.f8(v-for="values in argumentsForCEF[method]")
          label.mr4
            input.mr2(type='radio', :value="values", :name="`${method}`", @change="callCEF(method, values)")
            span {{values}}
      button.bg-black-overlay.white.b.f8.br1.pa2(type="button", @click="callCEF(method)", v-else) call method

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dev-panel {
  width: 300px;
}
</style>
